import { activateAbTestById, deactivateAbTestById, initAbRegistry } from './registry';

class ABTasty {

    getAbTestNames(): string[] {
        const abTestNames: string[] = [];
        const elements: NodeListOf<HTMLElement> = document.querySelectorAll('[data-ab-name]');

        elements.forEach((element: HTMLElement) => {
            if(element.dataset.abName){
                if (!abTestNames.includes(element.dataset.abName )) {
                    abTestNames.push(element.dataset.abName);
                }
            }
        });

        return abTestNames;
    }

    getLocalStorageName (name: string): string {
        return `ab_test_${name}`;
    }

    activeAbTestDefault (name: string, version: string): void {
        const toggledVersion = window.localStorage.getItem(this.getLocalStorageName(name)) ?? version;

        const abDataToRemove: NodeListOf<HTMLElement> = document.querySelectorAll(`[data-ab-name="${name}"]`);
        const abDataToActive: HTMLElement | null = document.querySelector(`[data-ab-name="${name}"][data-ab-version="${toggledVersion}"]`);

        let jsonBlock: HTMLDivElement | null;

        if (abDataToActive && abDataToActive.tagName === 'SCRIPT') {
            jsonBlock = document.createElement('div');
            jsonBlock.innerHTML = abDataToActive.innerHTML.trim();
            jsonBlock.setAttribute('data-ab-name', name);
            jsonBlock.setAttribute('data-ab-version', abDataToActive.getAttribute('data-ab-version') as string);
        }

        abDataToRemove.forEach((el: HTMLElement): void => {
            if (el.getAttribute('data-ab-version') === version && jsonBlock && el.parentNode) {
                el.parentNode.replaceChild(jsonBlock, el);
            } else if (((el.getAttribute('data-ab-version') !== "A" && version === "A") || jsonBlock) && el.parentNode) {
                el.parentNode.removeChild(el);
            }
        });
    }

    deactiveAbTest(baseName: string) {
        const name: string = this.getLocalStorageName(baseName);

        if (window.localStorage.getItem(name)) {
            window.localStorage.removeItem(name);
        }
        deactivateAbTestById(baseName);
    }

    activeAbTest(baseName: string, version = "B", force = false): void {
        const name: string = this.getLocalStorageName(baseName);

        if ((!window.localStorage.getItem(name) && !force) || (force && window.localStorage.getItem(name))) {

            const currentVersion: string = window.localStorage.getItem(name) ?? version;

            switch (baseName) {
                default:
                    this.activeAbTestDefault(baseName, currentVersion);
                    break;
            }

            window.localStorage.setItem(name, currentVersion);
            activateAbTestById(baseName, 'localStorage');
        }
    }

    start(): void {
        initAbRegistry();
        // @ts-ignore
        window.activeAbTest = this.activeAbTest.bind(this);
        // @ts-ignore
        window.deactiveAbTest = this.deactiveAbTest.bind(this);
    }
}

const ABTastyInstance: ABTasty = new ABTasty();
export default ABTastyInstance;
